var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tongxin-layout"
  }, [_c('SelectionStep', {
    attrs: {
      "title": "請選擇就診目的",
      "items": _vm.items
    },
    model: {
      value: _vm.selectedItem,
      callback: function callback($$v) {
        _vm.selectedItem = $$v;
      },
      expression: "selectedItem"
    }
  }), _c('div', {
    staticClass: "fixed-footer-navigation"
  }, [_c('TongxinNavigation', {
    attrs: {
      "canProceed": !_vm.isLoading,
      "backButtonIsVisible": true,
      "nextButtonIsVisible": true,
      "textForNextStep": "下一步"
    },
    on: {
      "back": _vm.goBack,
      "next": _vm.handleSubmit
    }
  })], 1), _vm.isLoading ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }